import React, { useState, useEffect } from 'react';
import { getMessages, updateMessageStatus, deleteMessage } from '../api';

const MessagesAdmin = () => {
  const [items, setItems]     = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  const load = async () => {
    setLoading(true);
    const res = await getMessages();
    if (res.success) setItems(res.data);
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const handleStatus = async (id, status) => {
    await updateMessageStatus(id, status);
    await load();
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this message?')) return;
    await deleteMessage(id);
    setSelected(null);
    await load();
  };

  const fmt = (d) => new Date(d).toLocaleString('en-IN', { day:'2-digit', month:'short', year:'numeric', hour:'2-digit', minute:'2-digit' });

  return (
    <div>
      <div className="admin-section-header">
        <h2>Messages <span style={{ fontSize:'0.8rem', fontWeight:500, color:'#6c757d', marginLeft:8 }}>({items.filter(i => i.status === 'new').length} new)</span></h2>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: selected ? '1fr 1fr' : '1fr', gap: 20 }}>
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead>
              <tr><th>Name</th><th>Email</th><th>Subject</th><th>Date</th><th>Status</th><th>Actions</th></tr>
            </thead>
            <tbody>
              {items.map(m => (
                <tr key={m.id} style={{ cursor:'pointer', background: selected?.id===m.id ? '#f0f4ff' : '' }}
                  onClick={() => { setSelected(m); if(m.status==='new') handleStatus(m.id,'read'); }}>
                  <td style={{ fontWeight:600 }}>{m.name}</td>
                  <td style={{ fontSize:'0.82rem', color:'#6c757d' }}>{m.email}</td>
                  <td style={{ maxWidth:140, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{m.subject}</td>
                  <td style={{ fontSize:'0.78rem', color:'#adb5bd', whiteSpace:'nowrap' }}>{fmt(m.created_at)}</td>
                  <td>
                    <select value={m.status} onClick={e => e.stopPropagation()}
                      onChange={e => handleStatus(m.id, e.target.value)}
                      style={{ padding:'4px 8px', border:'1.5px solid #dee2e6', borderRadius:6, fontSize:'0.78rem', cursor:'pointer' }}>
                      <option value="new">New</option>
                      <option value="read">Read</option>
                      <option value="replied">Replied</option>
                    </select>
                  </td>
                  <td onClick={e => e.stopPropagation()}>
                    <button className="btn-admin-primary btn-admin-sm btn-admin-danger" onClick={() => handleDelete(m.id)}>🗑</button>
                  </td>
                </tr>
              ))}
              {!items.length && <tr><td colSpan={6} style={{ textAlign:'center', color:'#adb5bd', padding:'40px' }}>No messages yet.</td></tr>}
            </tbody>
          </table>
        </div>

        {selected && (
          <div style={{ background:'white', borderRadius:14, padding:24, boxShadow:'0 2px 12px rgba(0,0,0,0.06)', border:'1px solid #f0f0f0' }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:20 }}>
              <h3 style={{ fontWeight:700, color:'#1a1a5e', fontSize:'1rem' }}>Message Detail</h3>
              <button onClick={() => setSelected(null)} style={{ background:'#f8f9fa', border:'1px solid #e9ecef', borderRadius:8, padding:'4px 10px', cursor:'pointer', fontSize:'0.8rem' }}>✕ Close</button>
            </div>
            <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
              {[
                ['From',    selected.name],
                ['Email',   selected.email],
                ['Subject', selected.subject],
                ['Date',    fmt(selected.created_at)]
              ].map(([l,v]) => (
                <div key={l}>
                  <div style={{ fontSize:'0.72rem', fontWeight:700, color:'#ff6b35', letterSpacing:'0.5px', textTransform:'uppercase', marginBottom:3 }}>{l}</div>
                  <div style={{ fontSize:'0.9rem', color:'#343a40', fontWeight: l.includes('From')||l.includes('Subject') ? 600 : 400 }}>{v}</div>
                </div>
              ))}
              <div>
                <div style={{ fontSize:'0.72rem', fontWeight:700, color:'#e8603a', letterSpacing:'0.5px', textTransform:'uppercase', marginBottom:6 }}>Message</div>
                <div style={{ background:'#f8f9fa', borderRadius:10, padding:'14px 16px', fontSize:'0.9rem', color:'#343a40', lineHeight:1.8, whiteSpace:'pre-wrap', border:'1px solid #e9ecef' }}>{selected.message}</div>
              </div>
              <a href={`mailto:${selected.email}?subject=Re: ${selected.subject}`}
                style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:8, padding:'11px', borderRadius:8, background:'linear-gradient(135deg,#16165a,#2d2d8e)', color:'white', textDecoration:'none', fontWeight:700, fontSize:'0.88rem', marginTop:4 }}>
                <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
                Reply via Email
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MessagesAdmin;
